export const CALL_NUMBER = Object.freeze({ SUPPORT: '+65 6123 4567', EMERGENCY: '995' });

// Fixed call destinations carry a number; care-team calls use the current patient's centre.
export const CALL_TARGET = Object.freeze({
  CARE_TEAM: { kind: 'patient-centre' },
  EMERGENCY: { labelKey: 'nkf.callSheet.emergencyServices', number: CALL_NUMBER.EMERGENCY },
  LOGIN_SUPPORT: {
    labelKey: 'nkf.callSheet.loginSupport',
    number: CALL_NUMBER.SUPPORT,
    introKey: 'nkf.callSheet.loginSupportIntro',
    illustration: 'nurse',
  },
});
